import { useTranslation } from 'i18n';
import { useId } from 'react';
import {
  Box,
  CenteredLoader,
  Chip,
  Dialog,
  DialogHeader,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from 'ui';
import { Download, Restore } from 'ui/icons';

interface DocumentHistoryProps {
  open: boolean;
  onClose: () => void;
  title: string;
  documentId?: number | null;
}

export const History = ({ open, onClose, title }: DocumentHistoryProps) => {
  const { t } = useTranslation('orders');
  // Fake data, replace this with a react-query call here
  const data = [
    {
      changedAt: 'Feb. 7, 2025, 2:52 p.m.',
      changedBy: 'Zoe Tattam',
      comment: '-',
      id: useId(),
      isCurrent: true,
    },
    {
      changedAt: 'Feb. 7, 2025, 2:52 p.m.',
      changedBy: 'Zoe Tattam',
      comment: 'Change type: file uploaded manually',
      id: useId(),
      isCurrent: false,
    },
    {
      changedAt: 'Feb. 7, 2025, 2:52 p.m.',
      changedBy: 'Zoe Tattam',
      comment: 'Change type: file uploaded manually',
      id: useId(),
      isCurrent: false,
    },
    {
      changedAt: 'Jan. 15, 2025, 12:05 p.m.',
      changedBy: 'Vinayak Bhave',
      comment: '-',
      id: useId(),
      isCurrent: false,
    },
  ];

  // This represents the `isLoading` state returned by the react-query call
  const isLoading = true;

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogHeader title={t('documentGeneration.history.title', { values: { title } })} onClose={onClose} />
      {isLoading ? (
        <Box
          sx={{
            my: 8,
          }}
        >
          <CenteredLoader />
        </Box>
      ) : null}
      {!isLoading && (
        <Box sx={{ m: 2, width: 'auto' }}>
          <TableContainer component={Paper}>
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell>#</TableCell>
                  <TableCell>{t('documentGeneration.history.columns.changedAt')}</TableCell>
                  <TableCell>{t('documentGeneration.history.columns.changedBy')}</TableCell>
                  <TableCell>{t('documentGeneration.history.columns.comment')}</TableCell>
                  <TableCell>{t('documentGeneration.history.columns.download')}</TableCell>
                  <TableCell>{t('documentGeneration.history.columns.restore')}</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {data.map((version, index) => (
                  <TableRow key={version.id}>
                    <TableCell>
                      {t('documentGeneration.history.values.version', {
                        values: { version: data.length - index },
                      })}
                      {version.isCurrent ? (
                        <Chip
                          label={t('documentGeneration.history.values.current')}
                          size="small"
                          color="success"
                          sx={{ ml: 1 }}
                        />
                      ) : null}
                    </TableCell>
                    <TableCell>{version.changedAt}</TableCell>
                    <TableCell>{version.changedBy}</TableCell>
                    <TableCell>{version.comment || '-'}</TableCell>
                    <TableCell>
                      <IconButton size="small" sx={{ color: 'primary.main' }}>
                        <Download />
                      </IconButton>
                    </TableCell>
                    <TableCell>
                      {!version.isCurrent && (
                        <IconButton size="small" color="primary">
                          <Restore />
                        </IconButton>
                      )}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      )}
    </Dialog>
  );
};
